import React, { useRef } from "react";
import { useAppSelector } from "@/hooks";

import MainTemplate from "@/components/Templates/MainTemplate";
import HeadSection from "./HeadSection";
import DetailsSection from "./DetailsSection";
import ApplySection from "./ApplySection";
import { isMobile } from "@/utils";

function CareersDetailPage() {
  const applySectionRef = useRef();

  const scrollToApplySection = () => {
    const element = applySectionRef.current;
    if (element) {
      applySectionRef.current.scrollIntoView({
        behavior: "smooth",
        block: isMobile ? "start" : "center",
      });
    }
  };

  const { isGetJobDetailLoading: isLoading, getJobDetailSuccess: success } =
    useAppSelector((state) => state.careersPage);

  return (
    <MainTemplate isLoading={isLoading} success={success}>
      <HeadSection scrollToApplySection={scrollToApplySection} />
      <DetailsSection />
      <ApplySection applySectionRef={applySectionRef} />
    </MainTemplate>
  );
}

export default CareersDetailPage;
